<template>
  <div class="group-header">
    <div class="left-icon" @click="addItem">
      <feather-icon icon="PlusIcon" size="20"/>
    </div>
    <div class="body">
      {{group}}
    </div>
    <div class="right-icon" @click="onClickToggleIcon">
      <feather-icon :class="{'open': open}" icon="ChevronDownIcon" size="20" :style="{visibility: itemCount > 0 ? 'visible' : 'hidden'}" />
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupHead",
  props: {
    group: String,
    value: Boolean,
    itemCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    addItem() {
      this.$emit('addItem', this.group);
    },
    onClickToggleIcon() {
      if (this.itemCount > 0) {
        this.open = !this.open;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.group-header {
  display: grid;
  grid-template-columns: auto 1fr auto;

  .body,
  .left-icon,
  .right-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.675rem;

    .feather-icon {
      transition: all ease 0.3s;
      background: #f9f9f9;

      &.open {
        transform: rotate(180deg);
      }
    }
  }
  .body {
    cursor: default;
  }
  .left-icon, .right-icon {
    cursor: pointer;
  }

  .left-icon {
    color:#7E72F2;
  }
}
</style>
